export const SCEN_COLORS = ["#9D00FF", "#FFB800", "#00C2FF"];
export const MAX_ACTIVE = 3;
const FIELDS = ["revenue_change_monthly", "expense_change_monthly", "one_time_cash", "growth_rate", "start_month", "label"];

export const pickAdj = (s) => Object.fromEntries(FIELDS.map((k) => [k, s[k]]).filter(([, v]) => v !== undefined));

export const runwayDelta = (s, baseRunway) => (s.runway_months ?? 24) - (baseRunway ?? 24);

export const deltaText = (s, baseRunway) => {
  const d = runwayDelta(s, baseRunway);
  if (s.runway_months == null && baseRunway == null) return "24+ mo, same";
  const txt = `${d >= 0 ? "+" : ""}${d.toFixed(1)} mo`;
  return s.runway_months == null ? `>${txt}` : txt;
};
